"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payments = void 0;
var headers_1 = require("../../shared/headers");
var client_1 = require("../../shared/http/client");
var Payments = /** @class */ (function () {
    function Payments(apiUrl, appDetails, apiSecurity) {
        this.client = client_1.HttpClient.create(apiUrl, apiSecurity.unauthorizedCallback);
        this.appDetails = appDetails;
        this.apiSecurity = apiSecurity;
    }
    Payments.client = function (apiUrl, appDetails, apiSecurity) {
        return new Payments(apiUrl, appDetails, apiSecurity);
    };
    /**
     * Fetches the existing products and its details
     */
    Payments.prototype.getProducts = function () {
        return this.client.get('/v3/stripe/products', this.headers());
    };
    /**
     * Creates and returns a new session identifier for the client to go to payment platform
     * @param payload
     */
    Payments.prototype.createSession = function (payload) {
        return this.client.post('/v2/stripe/session', {
            test: payload.test,
            lifetime_tier: payload.lifetime_tier,
            mode: payload.mode,
            priceId: payload.priceId,
            successUrl: payload.successUrl,
            canceledUrl: payload.canceledUrl,
        }, this.headers());
    };
    Payments.prototype.getSetupIntent = function () {
        return this.client.get('/setup-intent', this.headers());
    };
    Payments.prototype.getDefaultPaymentMethod = function () {
        return this.client.get('/default-payment-method', this.headers());
    };
    Payments.prototype.getInvoices = function (_a) {
        var startingAfter = _a.startingAfter, limit = _a.limit;
        var query = new URLSearchParams();
        if (startingAfter !== undefined)
            query.set('starting_after', startingAfter);
        if (limit !== undefined)
            query.set('limit', limit.toString());
        return this.client.get("/invoices?" + query.toString(), this.headers());
    };
    Payments.prototype.getUserSubscription = function () {
        return this.client.get('/subscriptions', this.headers()).catch(function (err) {
            var error = err;
            if (error.status === 404)
                return { type: 'free' };
            else
                throw err;
        });
    };
    Payments.prototype.getPrices = function () {
        return this.client.get('/prices', this.headers());
    };
    Payments.prototype.updateSubscriptionPrice = function (priceId) {
        return this.client.put('/subscriptions', { price_id: priceId }, this.headers());
    };
    Payments.prototype.cancelSubscription = function () {
        return this.client.delete('/subscriptions', this.headers());
    };
    Payments.prototype.createCheckoutSession = function (payload) {
        return this.client.post('/checkout-session', __assign({}, payload), this.headers());
    };
    /**
     * Returns the needed headers for the module requests
     * @private
     */
    Payments.prototype.headers = function () {
        return (0, headers_1.headersWithToken)(this.appDetails.clientName, this.appDetails.clientVersion, this.apiSecurity.token);
    };
    return Payments;
}());
exports.Payments = Payments;
